import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="cookie-banner"
export default class extends Controller {
  connect() {
    let isCookieAccepted = localStorage.getItem("cb_isCookieAccepted");
    if (isCookieAccepted === null) {
      localStorage.setItem("cb_isCookieAccepted", "no");
    }
    if(isCookieAccepted === "no") {
      let cookieBanner = document.getElementById("cb-cookie-banner")
      if (cookieBanner) {
        document.getElementById("cb-cookie-banner").style.display = "block";
      }
    }
  }

  hideCookieBanner() {
    localStorage.setItem("cb_isCookieAccepted", "yes");
    let cookieBanner = document.getElementById("cb-cookie-banner")
    if (cookieBanner) {
      document.getElementById("cb-cookie-banner").style.display = "none";
    }
  }
}
